export const BASE_URL = "https://kiosk-api.goldenribbonuae.com/api";

export const IMAGE_URL = "https://kiosk-api.goldenribbonuae.com";
